import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import is from './translation/is.json'
import en from './translation/en.json'

const resources = {
  is,
  en,
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'is',
    debug: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
